module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('ul', [_vm._l((_vm.steps), function(step, index) {
    return _c('li', [(!step.isOption) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Question',
          params: {
            id: step.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n        "), _c('span', {
      staticClass: "go-icon"
    }, [_c('i', {
      staticClass: "fa fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (step.isOption) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Option',
          params: {
            id: step.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v("\n        " + _vm._s(step.title) + "\n        "), _c('span', {
      staticClass: "go-icon"
    }, [_c('i', {
      staticClass: "fa fa-arrow-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.information) ? _c('li', {
    staticClass: "information"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.information)
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('router-link', {
    staticClass: "not-these",
    attrs: {
      "to": {
        name: 'Contact',
        query: {
          gim: '1'
        }
      }
    }
  }, [_vm._v("\n    Bunların Dışında\n    "), _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39717718"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Option.vue
// module id = 231
// module chunks = 1